.pillRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
  margin-bottom: var(--space-8);
}

.pill {
  height: var(--space-10);
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  padding: 0 var(--space-3);
  border: 0;
  border-radius: 999px;
  background: var(--color-primary-soft, #eef3ff);
  color: var(--color-primary-dark, #0b2f8a);
  font-size: var(--font-size-sm);
  font-weight: 600;
}

.pillRemove {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: var(--radius-full);
  background: transparent;
  color: currentColor;
  cursor: pointer;
  transition:
    background-color 140ms ease,
    color 140ms ease,
    transform 140ms ease;
}

.pillRemove:hover {
  background: rgb(180 35 24 / 10%);
  color: var(--color-danger);
}

.pillRemove:active {
  transform: scale(0.94);
}

.pillRemove:focus-visible {
  outline: 2px solid var(--color-focus-border);
  outline-offset: 2px;
}